import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PortalSettings, SessionService } from '@edl-development/edl-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserAssignmentRequest } from 'src/app/model/user-assignment-request.model';
import { ComplianceItemService } from 'src/app/services/compliance-item.service';
import { PortalHelpersService } from 'src/app/services/portal-helpers/portal-helpers.service';

@Component({
	selector: 'remove-user-cycle-modal',
	templateUrl: './remove-user-cycle-modal.component.html'
})
export class RemoveUserCycleModalComponent implements OnInit {
	@Input() itemId: string;
	@Input() userIds: string[];
	@Input() shouldSendNotifications: boolean;

    form: UntypedFormGroup;
    busy: boolean;
	portalSettings: PortalSettings

	constructor(
		public activeModal: NgbActiveModal,
		private formBuilder: UntypedFormBuilder,
		private complianceItemService: ComplianceItemService,
		public portalHelpersService: PortalHelpersService,
		public sessionService: SessionService
	) { }

	ngOnInit(): void {
		this.form = this.formBuilder.group({
			ShouldSendNotifications: [this.shouldSendNotifications ?? false, [Validators.required]]
		});
		this.portalSettings = this.sessionService.PortalSettings;
	}

	cancel() {
		this.activeModal.dismiss('cancel');
	}

	submit({ value, valid }: { value: { ShouldSendNotifications: boolean }, valid: boolean}) {
		if (valid) {
			this.busy = true;

			const request: UserAssignmentRequest = new UserAssignmentRequest();
			request.ItemID = this.itemId;
			request.AssignedUsers = this.userIds;
			request.ShouldSendNotifications = value.ShouldSendNotifications;

			this.complianceItemService
				.removeUserAssignments(request)
				.subscribe(() => {
					this.activeModal.close('confirm')
				}, () => {
					this.cancel();
				});
		}
	}
}
